import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from "../utilities/colors";
import spacings from "../utilities/spacings";

const PlaylistItemWrapper = styled.a`
  padding: 6px;
  cursor: pointer;
  margin-bottom: ${spacings.s};
  width: 50%;
  
  @media (max-width: 850px) {
    width: 100%;
  }
  
  &:hover, &:focus {
    background: ${colors.lightGrey};
  }

  .thumbnail-wrapper {
    width: 130px;
    background: ${colors.darkGrey};
    margin-right: ${spacings.s};
    > * {
      padding-bottom: 56%;
      background-position: center center;
      background-size: cover;
    }
  }
  
  .item-content {
    p {
      font-size: 12px;
    }
  }
  
  span {
    display: block;
    font-size: 12px;
  }
  
`;

const PlaylistItem = props => {
    return (
        <PlaylistItemWrapper className={'u-flex u-align-items-center'} onClick={props.onClick}>
            <div>
                <span className={'thumbnail-wrapper'}>
                    <span style={{backgroundImage: 'url(' + props.cover_image + ')'}} />
                </span>
            </div>
            <div className={'item-content'}>
                <h3 className={'h3'}>{ props.title }</h3>
                <span>{ props.short_description }</span>
            </div>
        </PlaylistItemWrapper>
    );
};

PlaylistItem.propTypes = {
    title: PropTypes.string.isRequired,
    cover_image: PropTypes.string.isRequired,
    short_description: PropTypes.string.isRequired,
};

export default PlaylistItem;
